<template>
  <div v-if="currentStep === 1" class="step-content">
    <div class="title">验证手机号：</div>
    <van-cell-group>
      <van-field
        class="phone"
        input-align="right"
        v-model="mobile"
        placeholder="请输入手机号"
        type="number"
        clearable
        :error-message="mobileError"
        @input="validateMobile"
      >
        <template #left-icon>
          <div class="label" @click="handleShowSheet">
            <span>{{ showLabel }}</span>
            <van-icon name="arrow-down" />
          </div>
        </template>
        <template #right-icon>
          <van-icon name="clear" size="16" @click="mobile = ''" v-if="mobile" />
        </template>
      </van-field>
    </van-cell-group>
    <van-button
      type="primary"
      @click="sendVerificationCode"
      :disabled="!isMobileValid || isCountingDown"
      class="btn"
    >
      {{ isCountingDown ? `${countdown}秒后重发` : "发送验证码" }}
    </van-button>
  </div>

  <!-- 步骤2：验证验证码 -->
  <div v-if="currentStep === 2" class="step-content">
    <div class="title2">
      验证手机号：
      <div class="tips" style="text-align: center">
        已发送4位验证码至
        <div>{{ mobileLabel }} {{ mobile }}</div>
      </div>
    </div>
    <van-cell-group>
      <van-field
        v-model="verificationCode"
        placeholder="请输入验证码"
        :error-message="codeError"
        @input="validateCode"
        clearable
      >
        <template #right>
          <van-icon name="clear" size="16" @click="verificationCode = ''" v-if="verificationCode" />
        </template>
      </van-field>
    </van-cell-group>
    <van-button type="primary" @click="verifyCode" :disabled="!isCodeValid" class="btn">
      确定
    </van-button>
    <div style="text-align: center">
      <a href="#" style="font-size: 14px; color: #1989fa" @click.prevent="resendCode">
        {{ isCountingDown ? `${countdown}秒后重发` : "重新发送" }}
      </a>
    </div>
  </div>

  <!-- 步骤3：设置新密码 -->
  <div v-if="currentStep === 3" class="step-content">
    <div class="title">请您设置新密码：</div>
    <van-cell-group>
      <van-field
        v-model="newPassword"
        placeholder="输入新的密码"
        :type="showNew ? 'text' : 'password'"
        :right-icon="showNew ? 'eye-o' : 'closed-eye'"
        :error-message="passwordError"
        @click-right-icon="showNew = !showNew"
        @input="validatePassword"
        clearable
      >
      </van-field>
      <van-field
        v-model="confirmPassword"
        placeholder="再次输入密码"
        :type="showConfirm ? 'text' : 'password'"
        :right-icon="showConfirm ? 'eye-o' : 'closed-eye'"
        :error-message="confirmError"
        @click-right-icon="showConfirm = !showConfirm"
        @input="validateConfirm"
        clearable
      >
      </van-field>
    </van-cell-group>
    <div class="tips" style="margin-top: 10px">
      6~20位密码，至少包含数字、英文字母、特殊符号中的2种
    </div>
    <van-button
      type="primary"
      @click="submit"
      :disabled="!isPasswordValid || !isConfirmValid"
      class="btn"
      style="width: 80%; margin-top: 20px"
    >
      完成
    </van-button>
  </div>

  <!-- 国家/地区代码选择器 -->
  <van-action-sheet
    v-model:show="showSheet"
    :actions="actions"
    @select="onSelect"
    cancel-text="取消"
    close-on-click-action
  />
</template>

<script>
import { Button, Field, CellGroup, Icon, Toast, ActionSheet } from "vant";
import { useStore } from "vuex";
import { onMounted, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import httpApi from "../../utils/httpApi";

// 国家/地区代码映射
const labelNameMap = {
  "+86": "中国大陆 +86",
  "+852": "中国香港 +852",
  "+853": "中国澳门 +853",
  "+886": "中国台湾 +886",
};

export default {
  name: "forget",
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [ActionSheet.name]: ActionSheet,
  },
  data() {
    return {
      // 步骤管理
      currentStep: 1,

      // 手机号验证
      mobile: "",
      mobileError: "",

      // 验证码验证
      verificationCode: "",
      codeError: "",

      // 密码验证
      newPassword: "",
      confirmPassword: "",
      showNew: false,
      showConfirm: false,
      passwordError: "",
      confirmError: "",

      // 验证码倒计时
      countdown: 60,
      isCountingDown: false,
      countdownTimer: null,

      // 国家/地区代码选择器
      showSheet: false,
      actions: [
        { name: "中国大陆 +86", value: "+86" },
        { name: "中国香港 +852", value: "+852" },
        { name: "中国澳门 +853", value: "+853" },
        { name: "中国台湾 +886", value: "+886" },
      ],
    };
  },
  computed: {
    // 手机号验证
    isMobileValid() {
      return this.mobile && !this.mobileError;
    },

    // 验证码验证
    isCodeValid() {
      return this.verificationCode && /^\d{4}$/.test(this.verificationCode) && !this.codeError;
    },

    // 密码验证
    isPasswordValid() {
      return this.newPassword && !this.passwordError;
    },

    // 确认密码验证
    isConfirmValid() {
      return this.confirmPassword && !this.confirmError;
    },
  },
  methods: {
    // 开始倒计时
    startCountdown() {
      this.isCountingDown = true;
      this.countdown = 60;

      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }

      this.countdownTimer = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.isCountingDown = false;
        }
      }, 1000);
    },

    // 验证手机号
    validateMobile() {
      if (!this.mobile) {
        this.mobileError = "请输入手机号";
      } else {
        this.mobileError = "";
      }
    },

    // 显示国家/地区代码选择器
    handleShowSheet() {
      this.showSheet = true;
    },

    // 选择国家/地区代码
    onSelect(item) {
      this.mobileLabel = item.value;
      this.showSheet = false;
    },

    // 发送验证码
    async sendVerificationCode() {
      this.validateMobile();
      if (!this.isMobileValid) {
        return;
      }

      try {
        // 调用API发送验证码
        const res = await httpApi.getPasswordCode({
          mobile: `${this.mobileLabel}-${this.mobile}`,
        });
        if (res.code === 200) {
          Toast("验证码发送成功");
          this.startCountdown();
          this.currentStep = 2;
        } else {
          Toast(res.msg || "验证码发送失败，请重试");
        }
      } catch (error) {
        Toast("验证码发送失败，请稍后重试");
      }
    },

    // 重新发送验证码
    async resendCode() {
      if (this.isCountingDown) {
        return;
      }

      try {
        // 调用API重新发送验证码
        const res = await httpApi.getPasswordCode({
          mobile: `${this.mobileLabel}-${this.mobile}`,
        });
        if (res.code === 200) {
          Toast("验证码重新发送成功");
          this.startCountdown();
        } else {
          Toast(res.msg || "验证码重新发送失败，请重试");
        }
      } catch (error) {
        Toast("验证码发送失败，请稍后重试");
      }
    },

    // 验证验证码
    validateCode() {
      if (!this.verificationCode) {
        this.codeError = "请输入验证码";
      } else if (!/^\d{4}$/.test(this.verificationCode)) {
        this.codeError = "请输入4位数字验证码";
      } else {
        this.codeError = "";
      }
    },

    // 验证验证码
    async verifyCode() {
      this.validateCode();
      if (!this.isCodeValid) {
        return;
      }

      try {
        // 调用API验证验证码
        const res = await httpApi.checkPasswordCode({
          mobile: `${this.mobileLabel}-${this.mobile}`,
          code: this.verificationCode,
        });
        if (res.code === 200) {
          Toast("验证码验证成功");
          this.currentStep = 3;
        } else {
          Toast(res.msg || "验证码验证失败，请重试");
        }
      } catch (error) {
        Toast("验证码验证失败，请稍后重试");
      }
    },

    // 验证密码
    validatePassword() {
      if (!this.newPassword) {
        this.passwordError = "请输入新密码";
      } else if (this.newPassword.length < 6 || this.newPassword.length > 20) {
        this.passwordError = "密码长度应为6~20位";
      } else if (
        !/^(?=.*[a-zA-Z0-9])(?=.*[a-zA-Z!@#$%^&*])(?=.*[0-9!@#$%^&*]).{6,20}$/.test(
          this.newPassword
        )
      ) {
        this.passwordError = "密码至少包含数字、英文字母、特殊符号中的2种";
      } else {
        this.passwordError = "";
      }

      // 验证确认密码
      if (this.confirmPassword) {
        this.validateConfirm();
      }
    },

    // 验证确认密码
    validateConfirm() {
      if (!this.confirmPassword) {
        this.confirmError = "请确认新密码";
      } else if (this.confirmPassword !== this.newPassword) {
        this.confirmError = "两次输入的密码不一致";
      } else {
        this.confirmError = "";
      }
    },

    // 提交新密码
    async submit() {
      this.validatePassword();
      this.validateConfirm();

      if (!this.isPasswordValid || !this.isConfirmValid) {
        return;
      }

      try {
        const nextUrl = this.$route.query.next_url || this.$route.query.nextUrl || "";
        const res = await httpApi.setPassword({
          password: this.newPassword,
        });
        if (res.code === 200) {
          Toast("密码设置成功");
          if (nextUrl) {
            this.$router.push(nextUrl);
          } else {
            this.$router.back();
          }
        } else {
          Toast(res.msg || "密码设置失败，请重试");
        }
      } catch (error) {
        Toast("密码设置失败，请稍后重试");
      }
    },
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    onMounted(() => {
      store.commit("setTitleValue", "忘记密码");
      store.commit("setStepsShow", false);
    });

    // 国家/地区代码
    const mobileLabel = ref("+86");
    const showLabel = computed(() => labelNameMap[mobileLabel.value]);

    return {
      route,
      router,
      mobileLabel,
      showLabel,
    };
  },
};
</script>

<style lang="less">
.step-content {
  margin-top: 60px;
  .phone {
    .label {
      display: flex;
    }
  }
  .title {
    color: @font-color-0;
    font-size: @font-size-2;
    padding-left: @space-2;
    padding-right: @space-2;
    padding-top: @space-4;
    padding-bottom: @space-5;
    display: flex;
    justify-content: left;
    align-items: center;
  }

  .title2 {
    color: @font-color-0;
    font-size: @font-size-1;
    padding-left: @space-1;
    padding-right: @space-1;
    padding-top: @space-2;
    padding-bottom: @space-2;
    text-align: left;

    .tips {
      color: @font-color-1;
      font-size: @font-size-2;
      margin-left: 50px;
    }
    .phone {
      color: @font-color-0;
      font-size: @font-size-1;
    }
  }
}

.tips {
  color: @font-color-1;
  font-size: @font-size-3;
}

.btn {
  width: 80%;
  margin: @space-1 auto;
  margin-top: 20px;
}
</style>
